import React from 'react';

const SubProcessList = ({ t, subData }) => {
    return (
        <div className="card card-custom card-stretch gutter-b">
            <div className="card-body pb-3">
                <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.subProcess.title")}</h3>
                <div className="d-flex mt-2">
                    {(subData?.length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : <div className="table-responsive col-lg-12" style={{width: '100%', overflowX:'scroll'}}>
                        <table className="table tableFreez table-head-custom table-vertical-center table-head-bg" >
                            <thead>
                                <tr className="text-left">
                                    <th className="pl-7" style={{textAlign: 'center'}}>{t("jobsManagement.infoJob.subProcess.sNo")}</th>
                                    <th style={{textAlign: 'center'}}>{t("jobsManagement.infoJob.subProcess.jobID")}</th>
                                    <th style={{textAlign: 'center'}}>{t("jobsManagement.infoJob.subProcess.date")}</th>
                                    <th style={{textAlign: 'center'}}>{t("jobsManagement.infoJob.subProcess.status")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {subData?.map(({id, date, status}, index) => 
                                    <tr key={index}>
                                        <td className="pl-7">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{index+1}</span>
                                        </td>
                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{id}</span>
                                        </td>
                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{date}</span>
                                        </td>
                                        <td>
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{status}</span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>}
                </div>
            </div>
        </div>
    );
};

export default SubProcessList;